import React from 'react';
import PropTypes from 'prop-types';
import {TextField} from '@acuity-brands/fusion';

/**
 * @note Only for use inside the Form component. If you need to use
 * the Fusion TextField component, use it directly.
 */
export const FusionInputAdapter = ({
  data,
  disabled,
  errors,
  field,
  handleChange,
  name,
}) => (
  <>
    <TextField
      disabled={disabled}
      error={errors && errors.length > 0}
      errorTextPosition={'left'}
      fullWidth={true}
      helperText={errors && errors.length > 0 ? errors[0] : null}
      label={field.label}
      name={name}
      onChange={({target: input}) => handleChange(input.value)}
      value={data ?? ''}
    />
  </>
);

FusionInputAdapter.propTypes = {
  data: PropTypes.any,
  disabled: PropTypes.bool,
  errors: PropTypes.arrayOf(PropTypes.string),
  field: PropTypes.shape({
    label: PropTypes.string.isRequired,
  }).isRequired,
  handleChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
};
